var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospitalicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.2106H16V15.7106H0V15.2106Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.4604H1V8.46603H3.75V8.96563H1.5V15.4604Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.4604H14.5V8.96563H12.25V8.46603H15V15.4604Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.4604H12V3.22021H9.75V2.72061H12.5V15.4604Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.4604H3.5V2.72061H6.25V3.22021H4V15.4604Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 1.97122H8.25V3.96962H7.75V1.97122Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.72061H9V3.22061H7V2.72061Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.96882H6V0.972015H10V4.96882ZM6.5 4.46922H9.5V1.47162H6.5V4.46922Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.4604H9.5V12.9624H6.5V15.4604H6V12.4628H10V15.4604Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.2138H5.5V9.21542H7.5V11.2138ZM6 10.7142H7V9.71502H6V10.7142Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.2138H8.5V9.21542H10.5V11.2138ZM9 10.7142H10V9.71502H9V10.7142Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.21621H5.5V6.2178H7.5V8.21621ZM6 7.7166H7V6.7174H6V7.7166Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.21621H8.5V6.2178H10.5V8.21621ZM9 7.7166H10V6.7174H9V7.7166Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalicon);
export default __webpack_public_path__ + "static/media/Hospitalicon.0d0b91fb41aa0fd821002498689f9cdb.svg";
export { ForwardRef as ReactComponent };